import { useState } from 'react';
import { Button } from '../button/Button';
import { fileWitnessReport } from '../../api/witness';
import styles from './Witness.module.css';

type Props = {
  code: string;
  token: string;
  playerNames: string[];
  myName: string;
};

export function WitnessReportForm({ code, token, playerNames, myName }: Props) {
  const [open, setOpen] = useState(false);
  const [killerName, setKillerName] = useState('');
  const [victimName, setVictimName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const others = playerNames.filter((n) => n !== myName);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!killerName || !victimName) return;
    setSubmitting(true);
    try {
      await fileWitnessReport(code, token, killerName, victimName);
      setDone(true);
      setKillerName('');
      setVictimName('');
      setTimeout(() => {
        setDone(false);
        setOpen(false);
      }, 2000);
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Failed to file report');
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) {
    return (
      <button type="button" className={styles.reportBtn} onClick={() => setOpen(true)}>
        Report attempted murder
      </button>
    );
  }

  return (
    <div className={styles.reportPanel}>
      {done ? (
        <p className={styles.reportSent}>Report filed — killer has been notified.</p>
      ) : (
        <form onSubmit={onSubmit} className={styles.reportForm}>
          <p className={styles.reportTitle}>Report attempted murder</p>
          <select
            className={styles.select}
            value={killerName}
            onChange={(e) => setKillerName(e.target.value)}
            required
          >
            <option value="">Select killer…</option>
            {others.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <select
            className={styles.select}
            value={victimName}
            onChange={(e) => setVictimName(e.target.value)}
            required
          >
            <option value="">Select victim…</option>
            {playerNames
              .filter((n) => n !== killerName)
              .map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
          </select>
          <div className={styles.reportActions}>
            <Button type="submit" disabled={submitting || !killerName || !victimName}>
              {submitting ? 'Sending…' : 'File report'}
            </Button>
            <Button variant="secondary" type="button" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
}
